<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">
    <!--comment  v-if="!navMenu"  vx-navbar-wrapper p-0-->
    <div class="vx-navbar-wrapper" :class="classObj" style="height:60px !important;z-index:10" v-if="!navMenu">
      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">

        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />

        <vs-spacer />

        <!-- <search-bar /> -->

        <!-- <i18n /> -->

        <WarningNotify :freshData="data"/>
        
        <!-- <support/> -->

        <profile-drop-down />

        <popup-package />

      </vs-navbar>
    </div>
  </div>
</template>


<script>
import SearchBar            from "./components/SearchBar.vue"
import NotificationDropDown from "./components/NotificationDropDown.vue"
import ProfileDropDown      from "./components/ProfileDropDown.vue"
import PopupPackage      from "./components/PopupPackage.vue"

import WarningNotify from '../../../views/pages/warning-notify/WarningNotify.vue'
import I18n from "../navbar/components/I18n.vue"
// import Support from './components/Support.vue'

export default {
  name: "the-navbar-vertical",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  components: {
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
    PopupPackage,
    WarningNotify,
    I18n
    // Support
  },
  data(){
    return{
      navMenu:false,
      data: null
    }
  },
  computed: {
    navbarColorLocal() {
      return this.$store.state.theme === "dark" && this.navbarColor === "#fff" ? "#10163a" : this.navbarColor
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor() {
      return {'text-white': (this.navbarColor != '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor != '#fff' && this.$store.state.theme !== 'dark')}
    },
    windowWidth() {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth == "default")      return "navbar-default"
      else if (this.verticalNavMenuWidth == "reduced") return "navbar-reduced"
      else if (this.verticalNavMenuWidth)              return "navbar-full"
    },
  },
  methods: {
    showSidebar() {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
    }
  },
  async created(){
    const navHeader = localStorage.getItem('verticalNav');
    if(navHeader == 'NavMenu'){
      this.navMenu = false;
    }
    else{
      this.navMenu = false;
    }
  },
  mounted(){
    this.$eventBus.$on('loadDataNotify',($event) =>{
        this.data = $event;
    });
  }
}
</script>
<style scoped>
.display-none{
  display: none;
}
.router-content{
  margin-top: 0rem !important;
}
.navbar-reduced {
  z-index: 1 !important;
}
</style>
